import instoreManageCardsModal from './instoreManageCardsModal';

export default instoreManageCardsModal;
